import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Big from 'big.js'
import zIndexScale from 'utils/zIndexScale'
import Select from '../common/Select'
import { Button } from '../common/Button'
import FlexBox from '../common/FlexBox'
import Input from '../common/Input'
import FontNumber from '../common/FontNumber'
import ErrSvg from '../../static/images/error-icon.svg'
import { roundValue } from '../../utils/number'
import Message from '../common/Message'

export const FormRow = styled.div`
  width: 450px;
  margin-top: 30px;
  /* border-bottom: 1px solid #DFE2E7; */
  position: relative;
  .title {
    color: #848e9c;
    font-size: 14px;
    line-height: 30px;
  }
  input {
    width: 90%;
    height: 30px;
    outline: none;
    /* border: none; */
    font-size: 16px;
  }
  #spin {
    opacity: 0;
  }
  input::-webkit-inner-spin-button {
    opacity: 0;
  }
  .textarea {
    width: 100%;
    outline: none;
    height: 50px;
    border: 1px solid #dfe2e7;
    font-size: 14px;
  }
  .amount-input {
    padding-right: 150px;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

const MaxAmount = styled.div`
  position: absolute;
  right: 20px;
  bottom: 10px;
  color: #f0b90b;
  cursor: pointer;
  z-index: ${zIndexScale.inputUnit};
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`

const Fee = styled.div`
  font-size: 14px;
  .fee-title {
    color: #48515d;
    margin-right: 5px;
  }

  .fee-value {
    color: #212833;
  }
`

const Available = styled.div`
  font-size: 14px;
  .Available-title {
    color: #48515d;
    margin-right: 5px;
  }

  .Available-value {
    color: #212833;
  }
`

const Symbol = styled.span`
  font-size: 16px;
  color: #212833;
  font-weight: 500;
`

const SymbolFullName = styled.span`
  font-size: 12px;
  color: #848e9c;
`

const ModalButton = styled(Button)`
  height: 34px;
  line-height: 34px;
  width: 90px;
  padding: 0 20px;
`

const ErrorMsg = styled.div`
  color: #f23051;
  position: absolute;
  bottom: -22px;
  left: 0;
  right: 0;
  font-size: 14px;
  display: flex;
  height: 20px;
  img {
    width: 15px;
    margin-right: 5px;
  }
`

export default class StepOne extends PureComponent {
  static propTypes = {
    bncClient: PropTypes.object.isRequired,
    assets: PropTypes.array,
    defaultAsset: PropTypes.object,
    next: PropTypes.func,
    to: PropTypes.string,
    memo: PropTypes.string,
    amount: PropTypes.number,
    transferFee: PropTypes.number,
  }

  static defaultProps = {
    assets: [],
    to: '',
    amount: '',
    memo: '',
    defaultAsset: {},
    next: () => {},
    transferFee: 0,
  }

  constructor(props) {
    super(props)
    const defaultAsset = props.defaultAsset || props.assets[0] || {}
    this.state = {
      asset: defaultAsset,
      to: props.to,
      amount: props.amount,
      addressErr: '',
      memoErr: '',
      memo: props.memo,
    }
  }

  _assetChange = asset => {
    const { assets } = this.props
    const assetObj = assets.find(item => item.asset === asset)
    this.setState({ asset: assetObj })
  }

  _toChange = value => {
    this.setState({ to: value, addressErr: '' })
  }

  _amountChange = value => {
    if (value === '') {
      this.setState({ amount: '' })
      return
    }
    const { asset } = this.state
    value = parseFloat(value)

    // check amount for bep8 token
    if (/.+-[a-zA-Z0-9]{3}m/i.test(asset.asset) && asset.totalBalance > 1 && value < 1) {
      this.setState({
        amountErr: 'The minimal amount should be greater than 1 when transfer bep8',
      })

      return
    }

    if (
      /.+-[a-zA-Z0-9]{3}m/i.test(asset.asset) &&
      asset.totalBalance < 1 &&
      value !== asset.totalBalance
    ) {
      this.setState({
        amountErr: 'The minimal amount should be equal your total balance',
      })

      return
    }

    const amount = parseFloat(asset.availableBalance, 10)
    if (asset.asset.toUpperCase() === 'BNB' && value === amount) {
      value = this._minusFee(value)
    }

    value = roundValue(value)

    this.setState({ amount: value, amountErr: '' })
  }

  _submit = () => {
    const { bncClient, next } = this.props
    const { amount, asset, to, memo } = this.state
    let errMsg = ''
    let addressMsg = ''

    if (!this._hasEnoughBnb()) {
      errMsg = 'the account doesn`t have enough bnb'
    }

    if (memo && memo.length >= 128) {
      this.setState({ memoErr: 'The length of memo should less than 128' })
      return
    }

    if (/[<>]+/.test(memo)) {
      this.setState({ memoErr: 'memo has special characters' })
      return
    }

    if (!to) {
      addressMsg = 'To address should not be null'
    }

    if (!bncClient.checkAddress(to)) {
      addressMsg = 'invalid address'
    }

    if (addressMsg) {
      this.setState({ addressErr: addressMsg })
      return
    }

    if (!amount) {
      errMsg = 'Amount should not be null'
    }

    if (parseFloat(amount, 10) > parseFloat(asset.availableBalance, 10)) {
      errMsg = 'Amount should be less than the max value'
    }

    if (errMsg) {
      this.setState({ amountErr: errMsg })
      return
    }

    // eslint-disable-next-line
    this.state.amount = roundValue(amount)

    this.setState(
      {
        amountErr: '',
        addressErr: '',
        memoErr: '',
      },
      () => {
        next && next(this.state)
      }
    )
  }

  _genAssetsOptions = () => {
    const { assets } = this.props
    return assets.map(item => ({
      value: item.asset,
      text: item.name,
      render: () => (
        <React.Fragment>
          <Symbol>{item.displayName}</Symbol>
          &nbsp;&nbsp;
          <SymbolFullName>{item.name}</SymbolFullName>
        </React.Fragment>
      ),
    }))
  }

  _hasEnoughBnb = () => {
    const { assets, transferFee } = this.props
    const bnb = assets.find(a => a.asset === 'BNB') || {}
    return bnb.availableBalance >= transferFee
  }

  _setMaxValue = () => {
    const { asset } = this.state
    const { transferFee } = this.props
    let amount = parseFloat(asset.availableBalance, 10)
    if (amount < transferFee) {
      Message.warn("You don't have enough available balances")
      return
    }
    if (asset.asset.toUpperCase() === 'BNB') {
      amount = this._minusFee(amount)
    }
    this.setState({ amount: roundValue(amount) })
  }

  _minusFee = amount => {
    const { transferFee } = this.props
    let result = new Big(amount)
    result = Number(result.minus(transferFee).toString())
    return result
  }

  _memoChange = e => {
    this.setState({ memo: e.currentTarget.value, memoErr: '' })
  }

  render() {
    const assetOptions = this._genAssetsOptions()
    const { to, amount, asset, memo, amountErr, addressErr, memoErr } = this.state
    const { transferFee } = this.props
    const defaultValue = assetOptions.find(item => item.value === asset.asset) || {}
    return (
      <div>
        <FormRow
          style={{
            borderBottom: 'none',
            marginTop: '20px',
            paddingBottom: '0',
          }}
        >
          <p className="title">Select Asset</p>
          <Select
            defaultValue={defaultValue.render && defaultValue.render()}
            options={assetOptions}
            width="100%"
            onChange={this._assetChange}
            withSearchBox={true}
          />
        </FormRow>
        <FormRow>
          <Input title="To Address" defaultValue={to} onChange={this._toChange} autoFocus={true} />{' '}
          {addressErr && (
            <ErrorMsg>
              <img src={ErrSvg} alt={true} />
              <span>{addressErr}</span>
            </ErrorMsg>
          )}
        </FormRow>
        <FormRow>
          <Input
            title="Amount to send"
            defaultValue={amount}
            type="number"
            onChange={this._amountChange}
            onFocus={this._amountChange}
          />
          <MaxAmount onClick={this._setMaxValue}>Max</MaxAmount>
          {amountErr && (
            <ErrorMsg>
              <img src={ErrSvg} alt={true} />
              <span>{amountErr}</span>
            </ErrorMsg>
          )}
        </FormRow>
        <FormRow
          style={{
            borderBottom: 'none',
          }}
        >
          <p className="title">Memo</p>
          <textarea className="textarea" value={memo} onChange={this._memoChange} />
          {memoErr && (
            <ErrorMsg>
              <img src={ErrSvg} alt={true} />
              <span>{memoErr}</span>
            </ErrorMsg>
          )}
        </FormRow>
        <FormRow
          style={{
            border: 'none',
            marginTop: '20px',
          }}
        >
          <Footer>
            <Fee>
              <span className="fee-title">Fee:</span>
              <span className="fee-value">
                <FontNumber value={transferFee} /> BNB
              </span>
            </Fee>
            <Available>
              <span className="Available-title">Available:</span>
              <span className="Available-value">
                <FontNumber value={asset.availableBalance} />
              </span>
            </Available>
          </Footer>
        </FormRow>
        <FlexBox
          style={{
            justifyContent: 'flex-end',
            marginTop: '16px',
          }}
        >
          <ModalButton onClick={this._submit}>
            <span>Next</span>
          </ModalButton>
        </FlexBox>
      </div>
    )
  }
}
